import styled, { css } from "styled-components/macro";
import { device } from "../../../device";

export const StyledTopbar = styled.nav`
	transition: 0.5s; /* 0.5 second transition effect to slide in the sidenav */
	width: 100%;
	${({ expended }) =>
		!expended &&
		css`
			padding: 1rem 1rem;
		`}
	position: static;
	z-index: 10;
	list-style: none;
	display: flex;
	gap: .5rem;
	align-items: center;
	align-items: top;
	padding: 1rem 2rem;


	a > svg {
		color: black;
	}
	@media ${device.mobileL}{
		padding 1rem;
	}	
`;
export const StyledTopbarLeft = styled.div`
	display: flex;
	gap: 1rem;
	flex-wrap: wrap;
`;
export const StylePageTitle = styled.span`
	font-weight: 600;
	font-size: 18px;
	color: #3a5558;
`;
export const StyledTrialDaysCounter = styled.li`
	font-weight: normal;
	font-size: 14px;
	line-height: 21px;
	color: #575e68;
	min-width: 140px;
	@media ${device.mobileL} {
		font-size: 10px;
		margin-top: 0.5rem;
	}
`;
